var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid",attrs:{"id":"home"}},[(_vm.authenticated)?[_c('Dashboard')]:[_c('Welcome')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }